import { getCookie } from './cookie';

export function getI18nCookieData() {
  const cookieValue = getCookie('i18n') || '||0||';
  const parts = cookieValue.split('|');
  return {
    country: parts[1],
    language: parts[2],
    languageIso2: parts[3],
    market: parts[4],
    region: parts[0],
  };
}
